<template>
    <div>
        <SToolbar dense>
            <KpIcon icon-cls="agenda" color="grey" left />
            <v-toolbar-title>{{ $t('veranstaltungen') }}</v-toolbar-title>
        </SToolbar>
        <div class="searchbar">
            <CompactSearchBar v-model="searchParams" @new-event="onNewEvent" @reset="onReset" />
        </div>
        <div class="main-container">
            <div class="searchresult">
                <EventCompactList ref="resultList" session-key="event-compact-list" :enhanced-filters="searchParams" />
            </div>
            <div class="editpanel">
                <!-- sub-route: /edit/compact/:id-->
                <RouterView @recordSaved="onRecordSaved" @recordDeleted="onRecordDeleted"></RouterView>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { RouterView } from 'vue-router';
import SessionStorageMixin from '@/mixins/session-storage';
import EventCompactList from '@/components/event/CompactList.vue';
import CompactSearchBar from '@/components/event/CompactSearchBar.vue';
import { errToStr } from '@/helpers/tools';

export default Vue.extend({
    name: 'EventCompactPanel',
    components: {
        CompactSearchBar,
        RouterView,
        EventCompactList,
    },
    mixins: [SessionStorageMixin],
    data() {
        this.sessionKey = 'EventCompactPanel';
        return {
            searchParams: this.getSessionValue('searchParams') || this.getInitialSearchParams(),
        };
    },
    watch: {
        searchParams(newVal, oldVal) {
            // we compare the CONTENT of the object (not the reference):
            if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                this.setSessionValue('searchParams', newVal);
            }
        },
    },

    methods: {
        reloadList() {
            this.$refs.resultList.reload();
        },
        onRecordSaved() {
            // reload the search list to update its entries after the event has changed:
            this.reloadList();
        },
        onNewEvent(event) {
            if (event?.getId()) {
                this.onRecordSaved();
                // open the compact edit route:
                this.$router.push({ name: 'event-compact-edit', params: { id: event.getId() } });
            }
        },

        onReset() {
            this.searchParams = this.getInitialSearchParams();
            this.reloadInitRoute();
        },

        reloadInitRoute() {
            const routeName = 'event-compact';
            if (this.$router.currentRoute.name !== routeName) {
                this.$router.push({ name: routeName });
            }
        },

        getInitialSearchParams() {
            return {
                event_status: [],
                schedule_date_from: null,
                schedule_date_to: null,
                ort: null,
                location_id: null,
                location_text: null,
                event_organizer_id: null,
                genre_group_ids: [],
                event_class: '',
                title: null,
                is_featured: null,
                for_print: null,
                cancelled: null,
                bp_import_uuid: [],
                edited: null,
                own_staff: null,
            };
        },

        async onRecordDeleted(event) {
            if (!event) {
                return;
            }

            if (confirm(this.$t('confirm_rec_delete'))) {
                try {
                    await event.delete();
                    this.reloadList();
                    this.reloadInitRoute();
                } catch (e) {
                    this.$toast({ message: errToStr(e), color: 'error' });
                }
            }
        },
    },
});
</script>

<style scoped lang="scss">
.main-container {
    display: grid;
    column-gap: 1rem;
    grid-template-rows: min-content;
    grid-template-columns: max-content minmax(1200px, auto);
    grid-template-areas:
        'searchbar searchbar'
        'searchresult editpanel';
    background-color: var(--toolbar-bg-color);
    overflow-y: hidden;
    overflow-x: auto;
    height: calc(var(--usable-height-with-toolbar) - 1rem);
}

.searchbar {
    grid-area: searchbar;
}

.searchresult {
    grid-area: searchresult;
    overflow: auto;
    padding: 0.5rem;
}

.editpanel {
    grid-area: editpanel;
    overflow: auto;
}
</style>
